import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer, Users, ShieldCheck, Copy } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatCard from "@/components/StatCard";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const fmt = (n) => new Intl.NumberFormat("ar-SA").format(n || 0);

export default function CharityReports() {
  const [stats, setStats] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/stats/charitable"),
      api.get("/beneficiaries", { params: { portal: "charitable" } }),
    ]).then(([s, b]) => { setStats(s.data); setItems(b.data); })
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  const byOccurrence = items.reduce((acc, b) => {
    const k = b.occurrence || 1;
    acc[k] = (acc[k] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="p-6 lg:p-10">
      <PageHeader
        title="تقارير البوابة الخيرية"
        actions={
          <Button
            data-testid="charity-report-print"
            variant="outline"
            onClick={() => window.open("/print/charitable/report", "_blank")}
            className="border-emerald-900 text-emerald-900 hover:bg-emerald-50"
          >
            <Printer className="h-4 w-4 ml-2" /> طباعة
          </Button>
        }
      />

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        <StatCard icon={Users} label="إجمالي التسجيلات" value={fmt(stats?.total_registrations)} tone="emerald" />
        <StatCard icon={ShieldCheck} label="مستفيدون فريدون" value={fmt(stats?.unique_beneficiaries)} tone="gold" />
        <StatCard icon={Copy} label="التكرارات" value={fmt(stats?.duplicates)} tone="white" />
      </div>

      <Card className="p-6 border-emerald-900/10 max-w-md">
        <h3 className="font-heading font-bold text-emerald-950 mb-4">توزيع التكرارات</h3>
        {Object.keys(byOccurrence).length === 0 ? (
          <p className="text-slate-500 text-sm">لا توجد بيانات.</p>
        ) : (
          <div className="space-y-2">
            {Object.entries(byOccurrence).sort((a, b) => a[0] - b[0]).map(([k, v]) => (
              <div key={k} className="flex justify-between items-center p-3 bg-slate-50 rounded-lg">
                <span className="text-emerald-950 font-medium">التسجيل رقم {k}</span>
                <span className="tabular-nums font-bold text-amber-700">{fmt(v)}</span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
